
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[address]/[[...slug]]",
      function () {
        return require("private-next-pages/[address]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[address]/[[...slug]]"])
      });
    }
  